export default __webpack_public_path__ + "c3468d41e1e1edd98ca08c9ff200b00c.ttf";